import { ButtonTertiary } from "components/Atoms/Button";
import React, { type PropsWithChildren } from "react";
import { cdn } from "utilities/cdnUtils";

interface ICalendarFeedHelpStepProps {
  label: string;
  text: React.ReactNode;
  imageName?: string;
}

export const ICalendarHelpStep = (props: PropsWithChildren<ICalendarFeedHelpStepProps>) => {
  return <div className="icalendar-feed-help-step">
    <div className="icalendar-feed-help-step-header">
      <h3 className="icalendar-feed-help-step-label">{props.label}</h3>
      {props.text && <div className="icalendar-feed-help-step-text">{props.text}</div>}
    </div>
    {props.imageName && <div className="icalendar-feed-help-step-image">
      <img src={cdn.static(`/images/icalinstruction/${props.imageName}`)} alt={props.label} />
    </div>}
  </div>
}

interface ICalendarFeedHelpStepWithButtonProps {
  label: string;
  buttonUrl: string;
}

export const ICalendarHelpStepWithButton = (props: PropsWithChildren<ICalendarFeedHelpStepWithButtonProps>) => {
  return <div className="icalendar-feed-help-step">
    <h3 className="icalendar-feed-help-step-label">{props.label}</h3>
    <div style={{
      width: 100,
    }}>
      <ButtonTertiary label="Click here" href={props.buttonUrl} />
    </div>
  </div>
}